import { PartitionSelector } from "domains/partitions/components/partition-selector";
import { Typography } from "@mui/material";
import localisations from "../../../localisation";
import { useCallback } from "react";
import { SelectedPartitionDetails } from "domains/partitions/components/partition-selector/PartitionSelector";

type SelectPartitionStageProps = {
    fieldCompanyId: number;
    fields: {
        partitionDetails?: SelectedPartitionDetails;
    };
    handleFieldChange: (fields: any) => void;
};

export default function SelectPartitionStage(props: SelectPartitionStageProps) {
    const { heading, blurb } = localisations.adjustmentAllocation.stages.selectPartition;
    const { fields, handleFieldChange } = props;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <br />
            <PartitionSelector
                fieldCompanyId={props.fieldCompanyId}
                initialPartitionId={fields.partitionDetails?.id}
                onSelected={useCallback((partitionDetails) => handleFieldChange({ partitionDetails: partitionDetails }), [handleFieldChange])}
            />

            <br />
            <br />
        </>
    );
}
